import React from 'react';
import { useEffect, useCallback } from 'react';

import './index.css';
import { BrowserRouter, Routes } from "react-router-dom";
import { routes } from "./routes/routes"
import ScrollToTop from "./ScrollToTop"
import { useState } from "react"
import ADNavbar from "./dist/ADNavbar"
import { ConditionalSnow } from './dist/helpers';

export default function Index() {
  const systemDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const [isDarkModeOverride, setDarkModeOverride] = useState(systemDarkMode);
  const [snowIsEnabled, setSnowIsEnabled] = useState(() => {
    const currentMonth = new Date().getMonth(); // 0 (Jan) to 11 (Dec)
    return currentMonth >= 10 || currentMonth <= 2; // Nov (10) through March (2)
  });

  const darkModeToggle = () => (
    <button
      className={`btn`}
      type="button"
      onClick={() => setDarkModeOverride(!isDarkModeOverride)}
      style={{ marginTop: "0rem" }}
    >
      {isDarkModeOverride ? "☀️" : "🌙"}
    </button>
  );

  const snowToggle = () => (
    <button
      className={`btn`}
      type="button"
      onClick={() => setSnowIsEnabled(!snowIsEnabled)}
      style={{ marginTop: "0rem" }}
    >
      {snowIsEnabled ? "☁️" : "❄️"}
    </button>
  );

  // Login state management
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);

  // Load login state from localStorage on component mount
  useEffect(() => {
    const savedLoginState = localStorage.getItem('loginState');
    if (savedLoginState) {
      try {
        const parsedState = JSON.parse(savedLoginState);
        setIsLoggedIn(parsedState.isLoggedIn);
        setUserData(parsedState.userData);
      } catch (error) {
        console.error('Error parsing saved login state:', error);
        localStorage.removeItem('loginState');
      }
    }
  }, []);

  // Save login state to localStorage whenever it changes
  useEffect(() => {
    if (isLoggedIn && userData) {
      localStorage.setItem('loginState', JSON.stringify({
        isLoggedIn,
        userData
      }));
    } else {
      localStorage.removeItem('loginState');
    }
  }, [isLoggedIn, userData]);

  // Function to update login state (called from Login component)
  const updateLoginState = useCallback((loginStatus, user) => {
    setIsLoggedIn(loginStatus);
    setUserData(user);
  }, []);

  // This is for determining distance from top of page
  let [shouldRemoveTransparent, setShouldRemoveTransparent] = useState(false);

  useEffect(() => {
    const handleScroll = event => {
      // console.log('window.scrollY', window.scrollY);
      const distanceFromTop = document.documentElement.scrollTop
      if (distanceFromTop > 70) {
        setShouldRemoveTransparent(true);
      } else {
        setShouldRemoveTransparent(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  return (
    <div
      style={{ backgroundColor: isDarkModeOverride ? "rgb(105, 159, 201)" : "#A0CFEB" }}>
      <React.StrictMode>
        <BrowserRouter>
          <ScrollToTop />
          <br />
          <ADNavbar {...{
            isDarkModeOverride,
            darkModeToggle,
            shouldRemoveTransparent,
            snowToggle,
            isLoggedIn,
            userData,
            updateLoginState
          }} />
          {ConditionalSnow(snowIsEnabled)}
          {ConditionalSnow(snowIsEnabled)}
          <Routes>
            {routes(isDarkModeOverride, updateLoginState, userData)}
          </Routes>
        </BrowserRouter>
      </React.StrictMode>
    </div>
  )
};


